import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const socials = [
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
  { icon: "ri-youtube-fill", label: "YouTube" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-primary-100 mt-16">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center text-primary-950">
                <i className="ri-play-circle-fill text-xl" />
              </span>
              <span className="text-lg font-bold text-background-50">
                一起草<span className="text-accent-400">视频</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200/80 max-w-xs">
              一起草视频是一个高清视频分享与在线观看平台，汇聚影视剧、娱乐节目与短视频内容，让每一次观看都轻松愉快。
            </p>
            <div className="flex items-center gap-2 mt-5">
              {socials.map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="w-9 h-9 rounded-full bg-primary-900 flex items-center justify-center text-primary-100 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">视频分类</h4>
            <ul className="space-y-3">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link to={`/category/${c.id}`} className="text-sm text-primary-200/80 hover:text-accent-400 transition-colors">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-primary-200/80 hover:text-accent-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/list/film" className="text-sm text-primary-200/80 hover:text-accent-400 transition-colors">
                  视频库
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-primary-200/80 hover:text-accent-400 transition-colors">
                  搜索视频
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-primary-200/80 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-3 text-sm text-primary-200/80">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5" />
                <span>hello@yiqicaoshipin.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5" />
                <span>400-800-1234（工作日 9:00-18:00）</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5" />
                <span>线上内容平台 · 全国服务</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300/70">
          <p>© 2026 一起草视频 yiqicaoshipin.com 保留所有权利</p>
          <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <span className="whitespace-nowrap cursor-pointer hover:text-accent-400 transition-colors">用户协议</span>
            <span className="whitespace-nowrap cursor-pointer hover:text-accent-400 transition-colors">隐私政策</span>
            <span className="whitespace-nowrap cursor-pointer hover:text-accent-400 transition-colors">版权声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}